import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="max-w-5xl mx-auto w-full px-6">
      <div className="p-6 rounded-md border bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-200">
        <h1 className="text-2xl font-bold mb-2">Cookie Policy</h1>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">Last updated: December 21, 2025</p>

        <p className="mb-4 text-left">
          Welcome to BorsAI ('we,' 'our,' or 'us'). This Cookie Policy explains how we use cookies and similar technologies on our website, borsai.net, to enhance your experience with our stock prediction and financial analysis service.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">What Are Cookies?</h2>
        <p className="mb-4 text-left">Cookies are small text files stored on your device when you visit our website. They help improve your browsing experience, enable certain functionalities, and provide insights to enhance our service.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">What Information We Collect</h2>
        <p className="mb-4 text-left">
          When you sign up or use our services, we may collect account information such as your name and email address.
          We use this information to create and manage your account, provide access to the platform, communicate with you about
          your account, and support authentication and security.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Types of Cookies and Storage We Use</h2>
        <h3 className="text-lg font-semibold mt-4 mb-2">Essential Cookies / Essential Storage</h3>
        <p className="mb-2 text-left">
          These cookies and/or browser storage are strictly necessary for the website to function properly and to provide secure
          login sessions. They may be used to keep you signed in, protect the site from abuse, and enable core account features.
        </p>

        <p className="mb-4 text-left">
          Because the platform requires authentication, you must agree to the use of essential cookies/storage for account and login
          functionality to proceed. If you do not agree, you will not be able to access the authenticated parts of the site.
        </p>

        <h3 className="text-lg font-semibold mt-4 mb-2">Analytics Cookies</h3>
        <p className="mb-4 text-left">These cookies help us understand how visitors interact with our website by collecting anonymous statistical data (e.g., via Google Analytics). Set only with your consent where required by law.</p>

        <h3 className="text-lg font-semibold mt-4 mb-2">Preference Storage (Optional)</h3>
        <p className="mb-4 text-left">
          We may store optional preferences (such as theme) to improve your experience. Where required, we will ask for your consent
          for non-essential storage.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Cookie Consent</h2>
        <p className="mb-4 text-left">
          Essential cookies/storage used for account and login functionality are required to use the platform. For non-essential
          cookies (such as analytics), we obtain your consent where required. You can withdraw consent or adjust preferences at any
          time via our consent mechanism (if available) or browser settings.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Cookie Duration</h2>
        <p className="mb-4 text-left">Essential cookies are typically session-based. Analytics cookies may persist longer per the third-party provider; we minimize retention where possible.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Third-Party Cookies</h2>
        <p className="mb-4 text-left">We use Google Analytics. These cookies are subject to Google’s privacy practices.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Cookie Management</h2>
        <p className="mb-2 text-left">Manage cookies via our consent mechanism (if applicable) or your browser settings (Chrome, Firefox, Safari, Edge).</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Updates to This Policy</h2>
        <p className="mb-4 text-left">We may update this policy periodically. Any changes will be posted on this page with an updated revision date.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us</h2>
        <p className="mb-1">Email: privacy@borsai.net</p>
        <p>Website: www.borsai.net</p>
      </div>
    </div>
  );
};

export default CookiePolicy;
